import { Button, Dropdown, Tag, Typography, theme } from 'antd';
import { DeleteOutlined, DownOutlined } from '@ant-design/icons';

import FlexBox from '../../atoms/FlexBox';
import FlexCol from '../../atoms/FlexCol';
import type { FileAttachment } from '../../../providers/AIContext';

interface ModelInputAttachmentsProps {
    attachments: FileAttachment[];
    onRemove: (att: FileAttachment) => void | Promise<void>;
    onRemoveAll: () => void | Promise<void>;
}

export default function ModelInputAttachments({
    attachments,
    onRemove,
    onRemoveAll,
}: ModelInputAttachmentsProps) {
    const { token } = theme.useToken();

    if (attachments.length === 0) return null;

    return (
        <Dropdown
            trigger={['click']}
            placement="topLeft"
            popupRender={() => (
                <FlexCol
                    noGrow
                    gap={5}
                    style={{
                        minWidth: 320,
                        maxWidth: 650,
                        padding: token.paddingSM,
                        background: token.colorBgElevated,
                        borderRadius: token.borderRadiusLG,
                        boxShadow: token.boxShadowSecondary,
                    }}
                >
                    <FlexBox noGrow stretch style={{ paddingBottom: token.paddingXS }}>
                        <Typography.Text type="secondary">
                            <small>{attachments.length} attachment{attachments.length !== 1 ? 's' : ''}</small>
                        </Typography.Text>
                        <Button
                            type="text"
                            size="small"
                            aria-label="Remove all attachments"
                            icon={<DeleteOutlined />}
                            onClick={onRemoveAll}
                        >
                            <small>Remove all</small>
                        </Button>
                    </FlexBox>
                    {attachments.map((att) => {
                        const key = att.fileFolder;
                        return (
                            <FlexBox
                                key={key}
                                noGrow
                                stretch
                                aria-label="attached-file-row"
                                // style={{ padding: `${token.paddingXXS}px ${token.paddingXS}px` }}
                            >
                                <Tag color="gray">{att.kind}</Tag>
                                <Typography.Text ellipsis style={{ flex: 1, minWidth: 0 }}>
                                    {att.filename}
                                </Typography.Text>
                                <Button
                                    type="text"
                                    size="small"
                                    aria-label={`Delete ${att.filename}`}
                                    icon={<DeleteOutlined />}
                                    onClick={() => onRemove(att)}
                                />
                            </FlexBox>
                        );
                    })}
                </FlexCol>
            )}
        >
            <Button
                aria-label="toggle-attachment-list"
                style={{ boxShadow: token.boxShadow }}
            >
                {attachments.length} attachment{attachments.length !== 1 ? 's' : ''}
                <DownOutlined />
            </Button>
        </Dropdown>
    );
}
